import { render, staticRenderFns } from "./newVote.vue?vue&type=template&id=7f6812fa&scoped=true&"
import script from "./newVote.vue?vue&type=script&lang=js&"
export * from "./newVote.vue?vue&type=script&lang=js&"
import style0 from "./newVote.vue?vue&type=style&index=0&id=7f6812fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6812fa",
  null
  
)

export default component.exports